import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useReactFlow } from "reactflow"

export default function DeleteTileWarningDialog({ open, onClose, node }) {
  const reactFlow = useReactFlow()

  function handleSoftClose() {
    onClose()
  }

  function handleDeleteButtonClicked() {
    reactFlow.setNodes((nodes) => nodes.filter((node2) => node.id !== node2.id))
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete this Tile?{" "}
          <strong>This is not reversible.</strong>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDeleteButtonClicked}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
